import { ActivityEndUser, CompanyData } from 'modules/accountActivity/domain'

export const LINKEDIN_BASE_URL = 'https://www.linkedin.com'
export const LINKEDIN_SEARCH_URL = LINKEDIN_BASE_URL + '/search/results/all/'

const extractNameFromEmail = (email: string | undefined): string | undefined => {
  if (email) {
    const parts = email.split('@')[0].split('.')
    if (parts.length === 2 && parts[0].length > 1 && parts[1].length > 1) {
      return parts[0] + ' ' + parts[1]
    }
  }
  return undefined
}

const buildLinkedInSearchKeywords = (
  endUser: ActivityEndUser | undefined,
  companyData: CompanyData | undefined
): string => {
  // 1. Check for name. If we have one, use that + company
  const endUserName = endUser?.name || extractNameFromEmail(endUser?.email)
  if (endUserName) {
    if (companyData?.name) {
      return endUserName + ' ' + companyData.name
    } else {
      return endUserName
    }
  }

  // 2. Otherwise use location if we have it
  if (companyData?.name) {
    if (endUser?.locationCity) {
      return companyData.name + ' ' + endUser.locationCity
    }
    return companyData.name
  }
  return ''
}

export const buildLinkedInSearchUrl = (
  endUser: ActivityEndUser | undefined,
  companyData: CompanyData | undefined
): string => {
  if (endUser?.linkedinHandle) {
    return `${LINKEDIN_BASE_URL}/${endUser.linkedinHandle}`
  }
  return `${LINKEDIN_SEARCH_URL}?keywords=
    ${encodeURIComponent(buildLinkedInSearchKeywords(endUser, companyData))}`
}
